import React from "react";
import { Img } from "../..";
import { FiArrowUpRight } from "react-icons/fi";
import { useNavigate } from "react-router-dom";

function InlineTeam({ team = {}, className = "" }) {
	const NAVIGATE = useNavigate();
	const { logo, name, id } = team;

	return (
		<div onClick={() => NAVIGATE(`/app/teams/${id}`)} className="inline-block px-2 py-1 align-middle rounded-md cursor-pointer bg-light hover:bg-primary hover:text-white">
			<div className={`align-center gap-x-1 ${className}`}>
				<Img preview placeholder="https://cdn.travelwings.com/assets/corp/images/placeholders/users.png" src={logo} className="w-4 h-4 rounded-full pixelated" />
				<div className="text-xs">{name}</div>
				<FiArrowUpRight />
			</div>
		</div>
	);
}

export default InlineTeam;
